<template>
    <div class="content content--aligned">
        <div v-if="currentPage.endsWith('/video-tutorials')">
            <h1>Video tutorials</h1>
            <p>Her finder du vejledninger til at lave fire forskellige spiltyper i Scratch/CodingLab:<br />
                scrollerspil, platformerspil, labyrintspil og skydespil.</p>
            <p>&nbsp;</p>
            <div class="game-type-list">
                <div class="game-type-list">
                    <div class="game-type-list-item">
                        <div class="game-type-description">
                            <h2>Scroller</h2>
                            <p>I et scrollerspil bliver du hele tiden på den samme skærm, men det ser ud som om du
                                bevæger dig, fordi andre ting i spillet, flytter sig.</p>
                            <p>Flappy Bird er et eksempel på et scrollerspil, hvor playeren kun kan bevæge sig op og
                                ned, mens de andre ting i spillet bevæger sig mod venstre og får det til at se ud som
                                om, at fuglen flyver mod højre.</p>
                        </div>
                        <router-link class="game-type-img-link" to="/video-tutorials/scroller">
                            <img src="/static/images/video-tuturials/scroller.png" alt="Lær at lave et scrollerspil" />
                        </router-link>
                        <p>
                            <router-link class="purp" to="/video-tutorials/scroller">Lær at lave et scrollerspil
                            </router-link>
                        </p>
                    </div>
                </div>

                <div class="game-type-list-item">
                    <div class="game-type-description">
                        <h2>Platformer</h2>
                        <p>Et spil hvor du skal hoppe fra platform til platform, undgå forhindringer og undgå at falde
                            ned.</p>
                        <p>Måske kan man samle mønter eller andre ting, for at få point.</p>
                        <p>Måske skal man også undgå at blive ramt af lyn eller at blive ædt farlige dyr ...</p>
                    </div>
                    <router-link class="game-type-img-link" to="/video-tutorials/platformer">
                        <img src="/static/images/video-tuturials/platformer.png" alt="Lær at lave et platformspil" />
                    </router-link>
                    <p>
                        <router-link class="purp" to="/video-tutorials/platformer">Lær at lave et platformspil
                        </router-link>
                    </p>
                </div>

                <div class="game-type-list">
                    <div class="game-type-list-item">
                        <div class="game-type-description">
                            <h2>Labyrint</h2>
                            <p>Et spil hvor du skal styre din karakter igennem en labyrint.</p>
                            <p>Måske skal du nå igennem labyrinten på tid, samle mønter, og/eller undgå
                                at blive ramt af bomber.</p>
                        </div>
                        <router-link class="game-type-img-link" to="/video-tutorials/labyrint">
                            <img src="/static/images/video-tuturials/labyrint.png" alt="Lær at lave et labyrintspil" />
                        </router-link>
                        <p>
                            <router-link class="purp" to="/video-tutorials/labyrint">Lær at lave et labyrintspil
                            </router-link>
                        </p>
                    </div>
                </div>
                <div class="game-type-list">
                    <div class="game-type-list-item">
                        <div class="game-type-description">
                            <h2>Skydespil</h2>
                            <p>Et spil hvor man skal skyde efter ting, objekter eller endda en
                                modspiller. </p>
                            <p>Kan laves så man spiller 2 mod hinanden. </p>
                        </div>
                        <router-link class="game-type-img-link" to="/video-tutorials/skyde">
                            <img src="/static/images/video-tuturials/skyde.png" alt="Lær at lave et skydespil" />
                        </router-link>
                        <p>
                            <router-link class="purp" to="/video-tutorials/skyde">Lær at lave et skydespil
                            </router-link>
                        </p>
                    </div>
                </div>


            </div>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
        </div>
        <div v-else>
            <h3>
                <router-link class="video-tut-backlink" to="/video-tutorials">
                    <img src="/static/images/arrow_back.png" style="vertical-align:middle; width: 22px;" />
                    <span>Video tutorials</span>
                </router-link>
            </h3>
        </div>
        <router-view style="padding-bottom: 35px" />
    </div>
</template>

<script>
export default {
    computed: {
        currentPage() {
            return this.$route.path;
        }
    }
};
</script>

<style scoped>
.video-tut-backlink {
    color: #7c00ff;
    text-decoration: none;
}

.game-type-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
    gap: 24px;
}

.game-type-list-item {
    background-color: #f1f1f1;
    padding-bottom: 24px;
}

.game-type-description {
    padding: 12px 24px 24px 24px;
}

.game-type-img-link {}

.game-type-img-link img {
    width: 100%;
}
</style>

<style>
.video-tut-embed img {
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/video-tutorials/index.vue